module.exports = __webpack_public_path__ + "static/media/android-og.551fd664.svg";